import PostList from '@components/blog/components/PostList'
import useT from '@hooks/useTranslation'

import styles from '@components/blog/styles/PostList.module.css'

export default function YouMightAlsoLike ({ posts }) {
    const ready = Boolean(posts?.length)
    return ready
        ? <section className={styles.recents}>
            <hr style={{ margin: '10px 0 30px' }} />
            { renderTitle() }
            <PostList data={posts} />
          </section>

        : null
}

function renderTitle () {
    return <h2 style={{ fontSize: '28rem' }}>
        {useT('Inne wpisy, które mogą Ci się spodobać')}:
    </h2>
}